/**
 * Full-screen maintenance page. Shown when /api/public/maintenance-status
 * returns { enabled: true }. Super admin can still reach /admin/* to disable.
 */
import { ShieldAlert, Clock } from "lucide-react";

export default function MaintenancePage({ message }) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0B1E4A] via-[#132B5F] to-[#1E3A8A] px-4" data-testid="maintenance-page">
            <div className="max-w-md w-full bg-white/95 backdrop-blur rounded-2xl shadow-2xl p-8 text-center ring-1 ring-white/20">
                <div className="mx-auto h-16 w-16 rounded-full bg-[#FEF3C7] flex items-center justify-center mb-4">
                    <ShieldAlert className="h-8 w-8 text-[#F59E0B]" />
                </div>
                <h1 className="text-2xl font-extrabold text-[#6D28D9] mb-2">
                    We&apos;ll be right back
                </h1>
                <p className="text-[14px] text-[#4B5563] leading-relaxed" data-testid="maintenance-message">
                    {message || "Site under maintenance. We'll be back shortly."}
                </p>
                <div className="mt-6 flex items-center justify-center gap-2 text-[12px] text-[#6B7280]">
                    <Clock className="h-4 w-4" />
                    <span>Please check back in a few minutes.</span>
                </div>
            </div>
        </div>
    );
}
